import { PHONE_REGEXP } from "./regExp";
import BigNumber from "bignumber.js";

export const validatePhone = (phone: string): boolean => {
    return PHONE_REGEXP.test(phone);
};

/**校验数字 */
export const validateNumber = (value: string | number) => {
    // 这里简单地示范一个检查是否为数字的例子
    if (typeof value === "number") {
        return true;
    } else if (typeof value === "string") {
        // 使用 parseInt() 或 parseFloat() 来验证字符串是否为数字
        return !isNaN(parseFloat(value));
    }
    // 如果 value 不是 string 或 number 类型，可以根据实际需求进行处理
    return false;
};

/**校验小数 */
export const validateDecimal = (value: string | number, decimal: number) => {
    if (!validateNumber(value)) {
        return false;
    }
    // 如果指定了小数点位数，则检查小数点位数是否符合要求
    if (decimal >= 0) {
        const decimalPlaces = (value.toString().split(".")[1] || "").length;
        if (decimalPlaces > decimal) {
            return false;
        }
    }
    return true;
};

/**校验最大值和最小值 */
export const validateNumRange = (value: string | number, max: number, min: number = 0, int: boolean = false) => {
    if (!validateNumber(value)) {
        return false;
    }
    // 将 value 转换为数字类型
    const numericValue = parseFloat(value.toString());

    // 检查是否超出最大值范围
    if (numericValue > max) {
        return false;
    }

    // 检查是否低于最小值范围
    if (numericValue < min) {
        return false;
    }

    if (int) {
        return validateDecimal(value, 0);
    }

    // 如果通过以上验证，则表示在最大值和最小值范围内
    return true;
};

/**校验正整数 */
export const validateInt = (value: string | number, max?: number) => {
    if (!validateNumber(value)) {
        return false;
    }
    if (!validateDecimal(value, 0)) {
        return false;
    }
    if (!validateNumRange(value, max ?? Number.MAX_SAFE_INTEGER, 1)) {
        return false;
    }
    return true;
};

/** 手机号校验正则 */
export const phoneReg = /^1[3456789]\d{9}$/;

/**
 * 生成范围校验函数（支持整数/小数）
 * @param {Object} options 配置项
 * @param {number} [options.min] 最小值，包含最小值
 * @param {number} [options.max] 最大值， 包含最大值
 * @param {string} [options.message] 自定义错误提示（可选）
 * @returns {Function} validator 函数
 */
export const numRangeValidator = (
    { min, max, message } = {
        min: 0.01,
        max: 9999999999.99,
        message: "请输入大于0小于100亿的数字"
    }
) => {
    return (_rule: unknown, value: string | number, callback: (error?: Error) => void) => {
        // 不校验必填
        if (new BigNumber(value).isNaN()) {
            callback();
        } else {
            const minValue = new BigNumber(min).isNaN() ? 0.01 : min;
            const maxValue = new BigNumber(max).isNaN() ? 9999999999.99 : max;
            // 包含最小值，  最大值
            if (new BigNumber(value).isLessThan(minValue) || new BigNumber(value).isGreaterThan(maxValue)) {
                callback(new Error(message || "请输入大于0小于100亿的数字"));
            } else {
                callback();
            }
        }
    };
};
